import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { siteContent } from "../content/siteContent";

const AboutSection = () => {
  const { kicker, title, image, points } = siteContent.about;
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        {/* Left */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-16 h-px bg-[#22b8db]" />
            <div className="text-[#22b8db] font-semibold tracking-widest uppercase text-xs">
              {kicker}
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a3a6e] mb-8 leading-tight">
            {title}
          </h2>

          <div className="space-y-6">
            {points.map((p) => (
              <div key={p.title} className="group">
                <div className="flex items-center gap-3 mb-2">
                  <CheckCircle2 className="w-5 h-5 text-[#22b8db]" />
                  <h3 className="text-lg font-bold text-[#1a3a6e]">{p.title}</h3>
                </div>
                <p className="text-slate-500 text-[14.5px] leading-relaxed pl-8">
                  {p.body}
                </p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 mt-9 bg-[#1a3a6e] hover:bg-[#12295a] text-white px-7 py-3.5 rounded-md font-semibold text-sm tracking-wide transition-colors shadow-md"
          >
            Discover About More <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Right image */}
        <div className="relative">
          <div className="absolute -top-6 left-8 right-0 h-16 bg-[#22b8db] rounded-t-lg" />
          <div className="relative rounded-lg overflow-hidden shadow-2xl">
            <img src={image} alt="Our team" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-lg p-5 shadow-xl hidden md:block">
            <div className="text-3xl font-extrabold text-[#1a3a6e]">10+</div>
            <div className="text-slate-500 text-sm font-medium">Years Experience</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
